module.exports = __webpack_public_path__ + "kids-logo.png";


//////////////////
// WEBPACK FOOTER
// ./src/js/components/pages/newLandingPage/block-categories/assets/kids-logo.png
// module id = 1172
// module chunks = 10